import {Switch} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {Field, FormikProps} from 'formik';
import {TextField} from 'formik-material-ui';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';

interface PasswordPolicyProps {
  formikProps: FormikProps<any>;
}

const PasswordPolicy = ({formikProps}: PasswordPolicyProps) => {
  const {pwdRequireMinLength, enablePasswordHistory, enableFailedLoginLockout} =
    formikProps.values;

  return (
    <Grid container spacing={2}>
      {/* Requerir número */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="pwdRequireNumber"
          label={i18n2._('Requerir Número')}
          onChange={(e: any) => {
            formikProps.setFieldValue('pwdRequireNumber', e.target.checked);
          }}
          checked={formikProps.values['pwdRequireNumber']}
        />
        <p style={{display: 'inline'}}>{i18n2._('Requerir Número')}</p>
      </Grid>

      {/* Requerir símbolo */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="pwdRequireSymbol"
          label={i18n2._('Requerir Símbolo')}
          onChange={(e: any) => {
            formikProps.setFieldValue('pwdRequireSymbol', e.target.checked);
          }}
          checked={formikProps.values['pwdRequireSymbol']}
        />
        <p style={{display: 'inline'}}>{i18n2._('Requerir Símbolo')}</p>
      </Grid>

      {/* Bloquear secuencias */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="pwdDisallowObviousSequences"
          label={i18n2._('Bloquear secuencias obvias')}
          onChange={(e: any) => {
            formikProps.setFieldValue(
              'pwdDisallowObviousSequences',
              e.target.checked,
            );
          }}
          checked={formikProps.values['pwdDisallowObviousSequences']}
        />
        <p style={{display: 'inline'}}>
          {i18n2._('Bloquear secuencias obvias')}
        </p>
      </Grid>

      {/* Bloquear datos personales */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="pwdDisallowUserData"
          label={i18n2._('Bloquear datos personales')}
          onChange={(e: any) => {
            formikProps.setFieldValue('pwdDisallowUserData', e.target.checked);
          }}
          checked={formikProps.values['pwdDisallowUserData']}
        />
        <p style={{display: 'inline'}}>
          {i18n2._('Bloquear datos personales')}
        </p>
      </Grid>

      {/* Requerir longitud mínima */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="pwdRequireMinLength"
          label={i18n2._('Longitud mínima')}
          onChange={(e: any) => {
            formikProps.setFieldValue('pwdRequireMinLength', e.target.checked);
          }}
          checked={formikProps.values['pwdRequireMinLength']}
        />
        <p style={{display: 'inline'}}>{i18n2._('Longitud mínima')}</p>
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          component={TextField}
          name="pwdMinLength"
          label={i18n2._('Cantidad')}
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          disabled={!pwdRequireMinLength}
        />
      </Grid>
      {/* Habilitar historización */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="enablePasswordHistory"
          label={i18n2._('Evitar reutilización de contraseñas')}
          onChange={(e: any) => {
            formikProps.setFieldValue(
              'enablePasswordHistory',
              e.target.checked,
            );
          }}
          checked={formikProps.values['enablePasswordHistory']}
        />
        <p style={{display: 'inline'}}>
          {i18n2._('Evitar reutilización de contraseñas')}
        </p>
      </Grid>

      {/* Cantidad de contraseñas a recordar */}
      <Grid item md={3} xs={12}>
        <Field
          component={TextField}
          name="passwordHistoryCount"
          label={i18n2._('Cantidad')}
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          disabled={!enablePasswordHistory}
          inputProps={{min: 0}}
        />
      </Grid>
      {/* Bloqueo por intentos fallidos */}
      <Grid item md={3} xs={12}>
        <Field
          component={Switch}
          name="enableFailedLoginLockout"
          label={i18n2._('Bloquear tras intentos fallidos')}
          onChange={(e: any) => {
            formikProps.setFieldValue(
              'enableFailedLoginLockout',
              e.target.checked,
            );
          }}
          checked={formikProps.values['enableFailedLoginLockout']}
        />
        <p style={{display: 'inline'}}>
          {i18n2._('Bloquear tras intentos fallidos')}
        </p>
      </Grid>

      <Grid item md={3} xs={12}>
        <Field
          component={TextField}
          name="failedLoginAttemptsLimit"
          label={i18n2._('Intentos permitidos')}
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          disabled={!enableFailedLoginLockout}
          inputProps={{min: 1}}
        />
      </Grid>
      {/* Expiración de token (minutos) */}
      <Grid item md={3} xs={12}>
        <Field
          component={TextField}
          name="tokenExpirationMinutes"
          label={i18n2._('Expiración de token (min)')}
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          inputProps={{min: 1}}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <Field
          component={TextField}
          name="idleTimeoutMinutes"
          label={i18n2._('Timeout por inactividad (min)')}
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          inputProps={{min: 1}}
        />
      </Grid>
    </Grid>
  );
};

export default PasswordPolicy;
